/**
 * Aba "Colunas": liga e desliga cada uma das nove colunas, escolhe quem a serve
 * (tema ou plugin) e edita as listas, os limiares e os textos dela.
 */
import { INFO_COLUNAS } from '@/utils/portal';
import type { PortalSiteDetalhe } from '@/types/portal';

import { CartaoSecao } from './CartaoSecao';
import {
  EditorAgro,
  EditorFonte,
  EditorFutebol,
  EditorHoroscopo,
  EditorLoterias,
  EditorMapa,
  EditorMercado,
  EditorServicos,
  EditorTempo,
} from './EditoresColuna';
import styles from './Portal.module.css';
import {
  validarAgro,
  validarFonte,
  validarFutebol,
  validarHoroscopo,
  validarLoterias,
  validarMapa,
  validarMercado,
  validarServicos,
  validarTempo,
} from './validacao';

export function AbaColunas({ detalhe }: { detalhe: PortalSiteDetalhe }) {
  const s = detalhe.secoes;
  const id = detalhe.site_id;
  const ativas = Object.values(s).filter((x) => 'ativa' in x && x.ativa).length;
  const noPlugin = Object.values(s).filter(
    (x) => 'servida_por' in x && x.ativa && x.servida_por === 'plugin',
  ).length;

  return (
    <div>
      <div className={styles.avisoInfo} role="note">
        <span className={styles.avisoTitulo}>
          {ativas} de 9 colunas ativas · {noPlugin} servidas pelo plugin
        </span>
        <span>
          Enquanto todas estiverem em "Tema", o plugin só lê o manifesto e não registra nada (modo
          sombra). Passe uma coluna por vez para "Plugin do WIREDESK" e confira na aba Conferência.
          Para desfazer, volte para "Tema": vale em até 5 minutos, sem deploy.
        </span>
      </div>

      <CartaoSecao
        siteId={id}
        secao={s.tempo}
        titulo={INFO_COLUNAS.tempo.rotulo}
        resumo={INFO_COLUNAS.tempo.resumo}
        validar={validarTempo}
      >
        {(ctx) => <EditorTempo {...ctx} />}
      </CartaoSecao>

      <CartaoSecao
        siteId={id}
        secao={s.mapa}
        titulo={INFO_COLUNAS.mapa.rotulo}
        resumo={INFO_COLUNAS.mapa.resumo}
        validar={validarMapa}
      >
        {(ctx) => <EditorMapa {...ctx} />}
      </CartaoSecao>

      <CartaoSecao
        siteId={id}
        secao={s.agro}
        titulo={INFO_COLUNAS.agro.rotulo}
        resumo={INFO_COLUNAS.agro.resumo}
        validar={validarAgro}
      >
        {(ctx) => <EditorAgro {...ctx} />}
      </CartaoSecao>

      <CartaoSecao
        siteId={id}
        secao={s.mercado}
        titulo={INFO_COLUNAS.mercado.rotulo}
        resumo={INFO_COLUNAS.mercado.resumo}
        validar={validarMercado}
      >
        {(ctx) => <EditorMercado {...ctx} />}
      </CartaoSecao>

      <CartaoSecao
        siteId={id}
        secao={s.horoscopo}
        titulo={INFO_COLUNAS.horoscopo.rotulo}
        resumo={INFO_COLUNAS.horoscopo.resumo}
        validar={validarHoroscopo}
      >
        {(ctx) => <EditorHoroscopo {...ctx} catalogos={detalhe.catalogos} />}
      </CartaoSecao>

      <CartaoSecao
        siteId={id}
        secao={s.loterias}
        titulo={INFO_COLUNAS.loterias.rotulo}
        resumo={INFO_COLUNAS.loterias.resumo}
        validar={validarLoterias}
      >
        {(ctx) => <EditorLoterias {...ctx} />}
      </CartaoSecao>

      <CartaoSecao
        siteId={id}
        secao={s.futebol}
        titulo={INFO_COLUNAS.futebol.rotulo}
        resumo={INFO_COLUNAS.futebol.resumo}
        validar={validarFutebol}
      >
        {(ctx) => <EditorFutebol {...ctx} catalogos={detalhe.catalogos} />}
      </CartaoSecao>

      <CartaoSecao
        siteId={id}
        secao={s.servicos}
        titulo={INFO_COLUNAS.servicos.rotulo}
        resumo={INFO_COLUNAS.servicos.resumo}
        validar={validarServicos}
      >
        {(ctx) => <EditorServicos {...ctx} />}
      </CartaoSecao>

      <CartaoSecao
        siteId={id}
        secao={s.fonte}
        titulo={INFO_COLUNAS.fonte.rotulo}
        resumo={INFO_COLUNAS.fonte.resumo}
        validar={validarFonte}
      >
        {(ctx) => <EditorFonte {...ctx} />}
      </CartaoSecao>
    </div>
  );
}
